import { PureComponent } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import HelpTooltip from 'ContentComponents/components/cmv2/HelpTooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import PersonalizationEditorContext from 'ContentComponents/context/PersonalizationEditorContext';
import { filterProps } from 'foundations-components/utils/filterProps';
import { HubDBIcon } from 'foundations-assets/icons/components/HubDBIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
class EditFormControl extends PureComponent {
  handleEditorClick(editor) {
    if (editor) editor.fire('OpenPersonalizePopover');
  }
  renderPersonalizationBrowser(fieldKey) {
    return /*#__PURE__*/_jsx(PersonalizationEditorContext.Consumer, {
      children: ({
        editorRefs
      }) => {
        return /*#__PURE__*/_jsx(FormControl, {
          children: /*#__PURE__*/_jsxs(Button, {
            use: "transparent",
            onClick: () => this.handleEditorClick(editorRefs[fieldKey] && editorRefs[fieldKey].editor),
            "data-test-id": "open-token-button",
            children: [/*#__PURE__*/_jsx(HubDBIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('edit')
            })]
          })
        });
      }
    });
  }
  renderItemRight({
    allowDataTokens,
    fieldKey,
    labelItemRight
  }) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [labelItemRight, allowDataTokens && this.renderPersonalizationBrowser(fieldKey)]
    });
  }
  render() {
    const {
      allowDataTokens,
      ['aria-label']: ariaLabel,
      ['data-field-key']: dataFieldKey,
      ['data-test-id']: dataTestId,
      error,
      onBlur,
      validationMessage,
      children,
      fieldKey,
      helpText,
      inlineHelpText,
      label,
      labelItemRight,
      noLabel,
      required,
      withPadding,
      handleFieldEditLinkOverride,
      shouldOverrideEditUrl,
      scrollToFieldPath
    } = this.props;
    const tooltip = helpText && /*#__PURE__*/_jsx(SanitizedLabel, {
      label: helpText
    });
    const helpTooltip = /*#__PURE__*/_jsx(HelpTooltip, {
      iconProps: {
        marginInlineStart: '200'
      },
      title: tooltip
    });
    let help;
    if (inlineHelpText) {
      if (shouldOverrideEditUrl && handleFieldEditLinkOverride) {
        help = /*#__PURE__*/_jsx(Link, {
          use: "unstyled",
          typography: "heading-25",
          onClick: () => handleFieldEditLinkOverride(scrollToFieldPath),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('edit')
          })
        });
      } else {
        help = /*#__PURE__*/_jsx(SanitizedLabel, {
          label: inlineHelpText,
          useStrict: true
        });
      }
    }
    const fieldLabel = label ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        "data-test-id": "cmv2-field-label",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          padding: "0",
          required: !!(label && required),
          children: typeof label === 'string' ? /*#__PURE__*/_jsx(SanitizedLabel, {
            label: label
          }) : label
        }), helpTooltip]
      }), this.renderItemRight({
        allowDataTokens,
        fieldKey,
        labelItemRight
      })]
    }) : null;
    const {
      tokenProps
    } = filterProps(this.props);
    return /*#__PURE__*/_jsx(FormControl, Object.assign({
      "aria-label": ariaLabel,
      "data-field-key": dataFieldKey,
      "data-test-id": dataTestId,
      error: error,
      help: help,
      label: fieldLabel,
      onBlur: onBlur,
      paddingBlockStart: noLabel ? '400' : '0',
      paddingInline: withPadding ? '600' : '0',
      validationMessage: validationMessage
    }, tokenProps, {
      children: children
    }));
  }
}
export default EditFormControl;